module.exports = __webpack_public_path__ + "img/h4.47fa31c7.png";